import React from "react";
import Swal from "sweetalert2";
import newsService from "../../../services/news.service";

const DeleteNews = (props: any) => {
  const { data } = props;
  const onDelete = () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `ข่าวประชาสัมพันธ์เรื่อง ${data.title}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("ใช้ต้องการลบเดียวนี้");
        newsService
          .delete(data.id)
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title:
                "ตรวจสอบว่ายังมีรายวิชาอยู่ในหลักสูตรนี้หรือไม่ ถ้ามีต้องลบก่อนครับ",
              showConfirmButton: true,
            });
          });
      }
    });
  };
  return (
    <button
      type="button"
      className="btn btn-sm btn-danger text-white ms-1"
      onClick={onDelete}
    >
      <i className="bi bi-trash3"></i> ลบ
    </button>
  );
};

export default DeleteNews;
